import { render } from "./PendingApprovalMedical.vue?vue&type=template&id=b826d5b6&scoped=true"
import script from "./PendingApprovalMedical.vue?vue&type=script&lang=js"
export * from "./PendingApprovalMedical.vue?vue&type=script&lang=js"

import "./PendingApprovalMedical.vue?vue&type=style&index=0&id=b826d5b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b826d5b6"]])

export default __exports__